const API_BASE: string = "/api"
export const API_AUTH: string = `${API_BASE}/auth`;